import { render, staticRenderFns } from "./TableConfTest.vue?vue&type=template&id=1ae31a6a&"
import script from "./TableConfTest.vue?vue&type=script&lang=js&"
export * from "./TableConfTest.vue?vue&type=script&lang=js&"
import style0 from "./TableConfTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports